module.exports = __webpack_public_path__ + "img/del.9b665f9d.svg";